<script setup lang="ts">
import { Check } from "@lucide/vue";
import { SelectItem, SelectItemIndicator, type SelectItemProps, SelectItemText } from "radix-vue";

const props = defineProps<SelectItemProps>();
</script>

<template>
	<SelectItem
		v-bind="props"
		:class="[
			'relative flex w-full cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:text-accent-foreground focus:bg-accent data-disabled:pointer-events-none data-disabled:opacity-50',
			$attrs.class,
		]"
	>
		<span class="flex size-3.5 items-center justify-end px-1">
			<SelectItemIndicator>
				<Check class="size-4" />
			</SelectItemIndicator>
		</span>

		<SelectItemText>
			<slot />
		</SelectItemText>
	</SelectItem>
</template>
